import React from 'react'
import styles from './iconStyles.module.scss'
export default function FaFile() {
  return (
    <div className={styles.faFile} />
  )
}
